export const calculateTTC = (ht, tva) => {
    // check if ht and tva are numbers, if they are strings, convert them to numbers
    if (typeof ht === 'string')
        ht = parseFloat(ht)
    if (typeof tva === 'string')
        tva = parseFloat(tva)

    // check if ht and tva are numbers
    if (isNaN(ht) || isNaN(tva))
        return null

    // convert decimal to integer to avoid floating point errors
    ht = ht * 100

    // calculate TTC
    const ttc = ht + (ht * tva / 100)
    // convert back to decimal
    // TODO: Respecter les règles d'arrondis quand celles-ci seront données
    return (ttc / 100).toFixed(2)
}

export const calculateHT = (ttc, tva) => {
    // check if ttc and tva are numbers, if they are strings, convert them to numbers
    if (typeof ttc === 'string')
        ttc = parseFloat(ttc)
    if (typeof tva === 'string')
        tva = parseFloat(tva)

    // check if ttc and tva are numbers
    if (isNaN(ttc) || isNaN(tva))
        return null

    // convert decimal to integer to avoid floating point errors
    ttc = ttc * 100

    // calculate HT
    const ht = ttc / (1 + tva / 100)
    // convert back to decimal
    // TODO: Respecter les règles d'arrondis quand celles-ci seront données
    return (ht / 100).toFixed(2)
}

const approximatelyEqual = (num1, num2, epsilon = 0.0001) => Math.abs(num1 - num2) < epsilon;

export const verifyCalculations = (entity, hasMultiVat = false, multiVatValues = []) => {
    
   return true;
	const {
        type,
        vat,
        vat_value,
        amount,
        amount_with_vat
    } = entity;
  
    const toFloat = (val) => parseFloat(val) || 0;
  
    const parsedVatValue = toFloat(vat_value);
    const parsedAmount = toFloat(amount);
    const parsedAmountWithVat = toFloat(amount_with_vat);

    const vatRateDecimal = toFloat(vat) / 100;
  
    // const calculateVatFromTotal = (total, rate) => +(total * rate / (1 + rate)).toFixed(2);
    const calculateVatFromTotal = (total, rate) => Math.round((total * rate) / (1 + rate) * 100) / 100;


    const isVatValueCorrect = 
        approximatelyEqual((parsedAmountWithVat - parsedAmount), parsedVatValue) &&
        // calculateVatFromTotal(parsedAmountWithVat, vatRateDecimal) === parsedVatValue;
        Math.abs(calculateVatFromTotal(parsedAmountWithVat, vatRateDecimal) - parsedVatValue) < 0.01;
  
    const isAmountCorrect =
        parsedAmountWithVat >= parsedAmount &&
        approximatelyEqual((parsedAmountWithVat - parsedVatValue), parsedAmount);
  
    let vatRate = hasMultiVat ? 0 : +((parsedVatValue / parsedAmount) * 100).toFixed(2);

    if (isNaN(vatRate)) vatRate = 0;
  
    if (hasMultiVat && Array.isArray(multiVatValues) && multiVatValues.length > 0) {
        const sumField = (field) => +multiVatValues.reduce((sum, item) => sum + toFloat(item[field]), 0).toFixed(2);
    
        const totalVat = sumField('vat_value');
        const totalAmount = sumField('amount');
        const totalWithVat = sumField('amount_with_vat');
    
        if (totalVat !== parsedVatValue) {
            throw new Error(`Le calcul ne correspond pas aux taux de TVA appliqués (${type})`, {
                cause: {
                    reason: 'miscalculation',
                    entity: { ...entity, toBeCorrected: { amount: true, vat_value: true, amount_with_vat: true } }
                }
            });
        }
  
        if (totalAmount !== parsedAmount) {
            throw new Error(`Le montant HT ne correspond pas au total des montants HT de TVA déroulés (${type})`, {
                cause: {
                    reason: 'miscalculation',
                    entity: { ...entity, toBeCorrected: { amount: true } }
                }
            });
        }
    
        if (totalWithVat !== parsedAmountWithVat) {
            throw new Error(`Le montant TTC ne correspond pas au total des montants TTC de TVA déroulés (${type})`, {
                cause: {
                    reason: 'miscalculation',
                    entity: { ...entity, toBeCorrected: { amount_with_vat: true } }
                }
            });
        }
    } else {
        if (
            (hasMultiVat && !isAmountCorrect) ||
            (!hasMultiVat && (!isVatValueCorrect || !isAmountCorrect))
        ) {
            const toBeCorrected = hasMultiVat
                ? { amount: true, vat: true, vat_value: true }
                : { amount: true, vat_value: true };

            throw new Error(`Le calcul n'est pas correct (${type})`, {
                cause: {
                    reason: 'miscalculation',
                    entity: { ...entity, toBeCorrected },
                },
            });
        }
    }
}
